import { createContext, useContext, useState } from 'react';

const StoreContext = createContext();

export function StoreProvider({ children }) {
  const [cart, setCart] = useState([]);
  const [wishlist, setWishlist] = useState([]);

  const addToCart = (product) => {
    setCart(prev => {
      const exists = prev.find(p => p.id === product.id);
      if (exists) {
        return prev.map(p => p.id === product.id ? { ...p, qty: p.qty + 1 } : p);
      }
      return [...prev, { ...product, qty: 1 }];
    });
  };

  const removeFromCart = (id) => setCart(prev => prev.filter(p => p.id !== id));

  const updateCartQty = (id, qty) => {
    setCart(prev => prev.map(p => p.id === id ? { ...p, qty: Math.max(1, qty) } : p));
  };

  const addToWishlist = (product) => {
    setWishlist(prev => {
      const exists = prev.find(p => p.id === product.id);
      if (exists) return prev;
      return [...prev, product];
    });
  };

  const removeFromWishlist = (id) => setWishlist(prev => prev.filter(p => p.id !== id));

  const isInWishlist = (id) => wishlist.some(p => p.id === id);

  const cartCount = cart.reduce((sum, p) => sum + p.qty, 0);
  const cartSubtotal = cart.reduce((sum, p) => sum + p.price * p.qty, 0);

  return (
    <StoreContext.Provider value={{
      cart, wishlist, cartCount, cartSubtotal,
      addToCart, removeFromCart, updateCartQty,
      addToWishlist, removeFromWishlist, isInWishlist,
    }}>
      {children}
    </StoreContext.Provider>
  );
}

export const useStore = () => useContext(StoreContext);